<template>
  <div class="background w-100 h-100 bg-size-cover bg-position-center" :style="bgStyles">
    
  </div>
</template>

<script>
export default {
  props: {
    css_var: { type: String, required: true }
  },
  computed:{
    bgStyles() {
      return {
        "background-image": `var(${this.css_var})`,
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.background{
  // height: 100vh;
  // width: 100vw;
  position:absolute;
  &::before{
    content: "";
    display: block;
    position: absolute;
    opacity: .6;
    background-color: black;
    height: 100vh;
    width: 100vw;
  }
}
</style>
